import { render, staticRenderFns } from "./FormMainInfo.vue?vue&type=template&id=25928fbc&scoped=true&"
import script from "./FormMainInfo.vue?vue&type=script&lang=js&"
export * from "./FormMainInfo.vue?vue&type=script&lang=js&"
import style0 from "./FormMainInfo.vue?vue&type=style&index=0&id=25928fbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25928fbc",
  null
  
)

export default component.exports